import { render, staticRenderFns } from "./CashflowCategoryNotification.vue?vue&type=template&id=23e2e14f&scoped=true&"
import script from "./CashflowCategoryNotification.vue?vue&type=script&lang=js&"
export * from "./CashflowCategoryNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2e14f",
  null
  
)

export default component.exports